import * as React from "react";
import Lead from "../../../../model/lead/Lead";
import {Option} from "ts-option";
import {editLead} from "../../../../store/action/lead/lead";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {ReasonForContact} from "./ReasonForContact";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import _ = require("underscore");

interface IProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface ReduxProps {
	/**
	 * Lead categories.
	 */
	categories: DictionaryItem[]
}

interface DispatchProps {
	/**
	 * Edit lead action.
	 * @param {Lead} lead
	 */
	editLead: (lead: Lead) => void;
}

interface IState {
	dropDownVisible: boolean;
}

type Props = IProps & ReduxProps & DispatchProps

class LeadReasonForContact extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.onRemove = this.onRemove.bind(this);
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
	}

	render() {
		const currentCategories = this.props.lead.map(l => {
			return l.data.categoriesIds.map(cId => {
				return this.props.categories.filter(cat => cat.id === cId)[0];
			})
		}).getOrElse([]);

		const availableCategories = _.difference(this.props.categories, currentCategories);

		return (
			<ReasonForContact availableCategories={availableCategories}
							  currentCategories={currentCategories}
							  onSelect={this.onSelect}
							  onRemove={this.onRemove}/>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(category: DictionaryItem) {
		this.props.lead.map(l => {
			const updatedCategories = l.data.categoriesIds.concat(category.id);
			const updatedLead = l.copy({data: l.data.copy({categoriesIds: updatedCategories})});
			this.props.editLead(updatedLead);
		})
	}

	onRemove(category: DictionaryItem) {
		this.props.lead.map(l => {
			const updatedCategories = l.data.categoriesIds.filter(cId => cId !== category.id);
			const updatedLead = l.copy({data: l.data.copy({categoriesIds: updatedCategories})});
			this.props.editLead(updatedLead);
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editLead: (lead: Lead) => dispatch(
			editLead(
				lead,
				() => Toast.success("Lead reason for contact updated", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

function mapStateToProps(state: RootState) {
	return {
		categories: state.category.categories.getOrElse([])
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadReasonForContact)